import { render } from "./AllertCart.vue?vue&type=template&id=5d4d49a8"
import script from "./AllertCart.vue?vue&type=script&lang=js"
export * from "./AllertCart.vue?vue&type=script&lang=js"

import exportComponent from "/srv/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__